import { render } from "./Esdevenir.vue?vue&type=template&id=1580c833"
import script from "./Esdevenir.vue?vue&type=script&lang=js"
export * from "./Esdevenir.vue?vue&type=script&lang=js"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__